// extracted by mini-css-extract-plugin
export var displayNone = "_oh-6";
export var imgContainer = "_oh-2";
export var overflowHidden = "_oh-3";
export var productInfoCardButtonContainer = "_oh-5";
export var productTitleText = "_oh-4";
export var rightArrow = "_oh-1";
export var rightArrowContainer = "_oh-0";